import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './fotos-bij-boek.css'

const FotosBijBoek = (props) => {
  return (
    <div className="fotos-bij-boek-container1">
      <Helmet>
        <title>Fotos-bij-boek - Schrijf je vrij</title>
        <meta property="og:title" content="Fotos-bij-boek - Schrijf je vrij" />
      </Helmet>
      <div className="fotos-bij-boek-top-container">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name26"></NavbarInteractive>
      </div>
      <div id="main-section" className="fotos-bij-boek-main">
        <div className="fotos-bij-boek-container2">
          <h1 className="fotos-bij-boek-text1">
            <span className="fotos-bij-boek-text2">Als je niets bent</span>
            <br></br>
            <span className="fotos-bij-boek-text4 Subtitel">
              Twee kanten van een oorlog
            </span>
            <br></br>
          </h1>
          <span className="fotos-bij-boek-text6">
            Hier vind je foto&apos;s en documenten behorende bij het boek. Klik
            op Albert Gerrits of Albert Woltjes om de foto&apos;s te bekijken.
            Met de pijltjes klik je door de plaatjes heen. Elke afbeelding heeft
            een stukje begeleidende tekst ter verduidelijking.
          </span>
          <div className="fotos-bij-boek-container3">
            <Link
              to="/fotos-albert-gerrits"
              className="fotos-bij-boek-navlink1"
            >
              <div className="fotos-bij-boek-container4">
                <img
                  alt="image"
                  src="/Albert Gerrits/0%20albert%20gerrits-400h.jpg"
                  className="fotos-bij-boek-image1"
                />
                <span className="fotos-bij-boek-text7 Button">
                  Foto&apos;s Albert Gerrits
                </span>
              </div>
            </Link>
            <div className="fotos-bij-boek-container5">
              <Link
                to="/fotos-albert-woltjes"
                className="fotos-bij-boek-navlink2"
              >
                <img
                  alt="image"
                  src="/Albert Woltjes/0%20albert%20woltjes-1000w.jpg"
                  className="fotos-bij-boek-image2"
                />
              </Link>
              <span className="fotos-bij-boek-text8 Button">
                Foto&apos;s Albert Woltjes
              </span>
            </div>
          </div>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name26"></Footer>
    </div>
  )
}

export default FotosBijBoek
